export default __webpack_public_path__ + "c1e571c344fdfaf16655321f6b74f200.png";